export const ERROR_MESSAGES = {
  MISSING_REQUIRED_FIELDS:
    'Required Field(s) Empty. See highlighted field(s) and fill out with the correct value.',
  MISSING_CLIENT_FIELD:
    'No Client Selected. Search a client and select one from the results.',
};

export const SUBMISSION_SUCCESS_MESSAGE = 'Commission enquiry sent.';
export const SUBMISSION_FAILED_MESSAGE = 'Failed to send commission enquiry.';
